import { createAsyncThunk } from '@reduxjs/toolkit';

import { StatusEnum } from '@common/constants';
import { fetch } from '@common/fetch';
import { downLoadFromBlob } from '@common/utils';

import { ParamsWithDependentUserId } from '../../../types';
import { immunizationsStatusSelector } from './selectors';
import { ImmunizationsItem } from './types';

export const getImmunizations = createAsyncThunk<ImmunizationsItem[], ParamsWithDependentUserId>(
  'HealthSummary/get-immunizations',
  async ({ dependentUserId }, { rejectWithValue }) => {
    try {
      const data = fetch.get({
        url: '/HealthSummary/immunizations',
        params: {
          dependentUserId,
        },
      });

      const res = await data.response;

      return res?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
  {
    condition: (_, { getState }) => immunizationsStatusSelector(getState() as RootState) !== StatusEnum.Pending,
  },
);

export const downloadImmunizationsReport = createAsyncThunk<unknown, ParamsWithDependentUserId>(
  'HealthSummary/immunizations-report',
  async ({ dependentUserId }, { rejectWithValue }) => {
    try {
      const data = fetch.get({
        url: '/HealthSummary/reports/immunizations',
        responseType: 'blob',
        params: { dependentUserId },
      });

      const res = await data.response;
      const blob = res?.data;
      downLoadFromBlob(blob, 'application/pdf', 'immunizations-report');
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
